var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 6.205a.69.69 0 0 0-.225-.58l-1.66-1.994v-.298H6.49l3.983 8.713 3.503-8.713h4.913v.298l-1.42 1.357a.41.41 0 0 0-.157.397v9.971a.41.41 0 0 0 .158.397l1.386 1.357v.297h-6.972v-.297l1.436-1.39c.14-.14.14-.182.14-.397v-8.06L9.47 17.376h-.54L4.282 7.264v6.776a.93.93 0 0 0 .257.778l1.868 2.258v.299H1.11v-.299l1.867-2.258a.9.9 0 0 0 .241-.777z",
    clipRule: "evenodd"
  })));
};
export default SvgMedium;